// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import { useState } from 'react'
import { supabase } from '../supabase'

const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  amber: '#B8721F', amberLight: '#D4902A', brown: '#2C1D14',
  muted: '#9A7B68', success: '#2E6B4A', danger: '#B03020',
  successBg: '#EBF5EF', dangerBg: '#FDECEA',
}

const S = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(44,29,20,0.5)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000, padding: '20px', fontFamily: 'Georgia, serif',
  },
  modal: {
    background: C.card, borderRadius: '16px', width: '100%',
    maxWidth: '540px', maxHeight: '90vh', overflowY: 'auto',
    boxShadow: '0 8px 40px rgba(44,29,20,0.2)',
    border: `1px solid ${C.border}`,
  },
  header: {
    padding: '24px 28px 0', display: 'flex',
    justifyContent: 'space-between', alignItems: 'center',
  },
  title: { fontSize: '22px', fontWeight: '700', color: C.brown },
  closeBtn: {
    background: 'none', border: 'none', fontSize: '22px',
    cursor: 'pointer', color: C.muted, padding: '0', lineHeight: 1,
  },
  body: { padding: '20px 28px 28px' },
  label: {
    fontSize: '10px', color: C.muted, letterSpacing: '1.5px',
    textTransform: 'uppercase', marginBottom: '5px', display: 'block',
    fontFamily: 'Calibri, sans-serif',
  },
  input: (focused) => ({
    width: '100%', background: C.bg,
    border: `1px solid ${focused ? C.amber : C.border}`,
    borderRadius: '8px', padding: '11px 14px', fontSize: '15px',
    fontFamily: 'Georgia, serif', color: C.brown, boxSizing: 'border-box',
    outline: 'none', marginBottom: '14px', transition: 'border-color 0.2s',
  }),
  select: (focused) => ({
    width: '100%', background: C.bg,
    border: `1px solid ${focused ? C.amber : C.border}`,
    borderRadius: '8px', padding: '11px 14px', fontSize: '15px',
    fontFamily: 'Georgia, serif', color: C.brown, boxSizing: 'border-box',
    outline: 'none', marginBottom: '14px', cursor: 'pointer',
    appearance: 'none', WebkitAppearance: 'none',
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%239A7B68' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat', backgroundPosition: 'right 14px center',
    paddingRight: '36px',
  }),
  textarea: (focused) => ({
    width: '100%', background: C.bg,
    border: `1px solid ${focused ? C.amber : C.border}`,
    borderRadius: '8px', padding: '11px 14px', fontSize: '15px',
    fontFamily: 'Georgia, serif', color: C.brown, boxSizing: 'border-box',
    outline: 'none', marginBottom: '14px', resize: 'vertical', minHeight: '80px',
  }),
  row: { display: 'flex', gap: '12px' },
  field: { flex: 1 },
  typeToggle: {
    display: 'flex', gap: '10px', marginBottom: '24px',
  },
  typeBtn: (active) => ({
    flex: 1, padding: '12px', borderRadius: '10px', cursor: 'pointer',
    textAlign: 'center', transition: 'all 0.2s',
    background: active ? `linear-gradient(135deg, ${C.amber}, ${C.amberLight})` : C.bg,
    border: `1px solid ${active ? C.amber : C.border}`,
    color: active ? C.card : C.brown,
  }),
  typeBtnIcon: { fontSize: '20px', marginBottom: '4px' },
  typeBtnLabel: (active) => ({
    fontSize: '12px', fontWeight: active ? '700' : '400',
    fontFamily: 'Calibri, sans-serif', color: active ? C.card : C.brown,
  }),
  typeBtnSub: (active) => ({
    fontSize: '10px', fontFamily: 'Calibri, sans-serif',
    color: active ? `${C.card}cc` : C.muted, marginTop: '2px',
  }),
  serviceGrid: {
    display: 'grid', gridTemplateColumns: '1fr 1fr 1fr',
    gap: '10px', marginBottom: '20px',
  },
  serviceCard: (selected) => ({
    background: selected ? '#FBF3E8' : C.bg,
    border: `1px solid ${selected ? C.amber : C.border}`,
    borderRadius: '10px', padding: '12px 8px', cursor: 'pointer',
    textAlign: 'center', transition: 'all 0.2s',
  }),
  serviceIcon: { fontSize: '22px', marginBottom: '4px' },
  serviceName: (selected) => ({
    fontSize: '11px', color: selected ? C.amber : C.brown,
    fontWeight: selected ? '700' : '400',
    fontFamily: 'Calibri, sans-serif', lineHeight: 1.3,
  }),
  btn: (disabled) => ({
    width: '100%',
    background: disabled ? C.border : `linear-gradient(135deg, ${C.amber}, ${C.amberLight})`,
    border: 'none', borderRadius: '10px', padding: '14px',
    color: disabled ? C.muted : C.card, fontSize: '14px', fontWeight: '700',
    letterSpacing: '2px', textTransform: 'uppercase',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontFamily: 'Georgia, serif', marginTop: '6px',
  }),
  cancelBtn: {
    width: '100%', background: 'transparent',
    border: `1px solid ${C.border}`, borderRadius: '10px', padding: '12px',
    color: C.muted, fontSize: '13px', letterSpacing: '1px',
    textTransform: 'uppercase', cursor: 'pointer',
    fontFamily: 'Georgia, serif', marginTop: '10px',
  },
  alert: (type) => ({
    borderRadius: '8px', padding: '10px 14px', marginBottom: '16px',
    fontSize: '13px', fontFamily: 'Calibri, sans-serif',
    background: type === 'error' ? C.dangerBg : C.successBg,
    border: `1px solid ${type === 'error' ? C.danger : C.success}44`,
    color: type === 'error' ? C.danger : C.success,
  }),
  sectionTitle: {
    fontSize: '11px', color: C.muted, letterSpacing: '2px',
    textTransform: 'uppercase', marginBottom: '12px',
    fontFamily: 'Calibri, sans-serif',
  },
  stepBar: { display: 'flex', gap: '6px', marginBottom: '20px' },
  stepBarItem: (active) => ({
    flex: 1, height: '3px', borderRadius: '2px',
    background: active ? C.amber : C.border, transition: 'all 0.3s',
  }),
}

const recurringServices = [
  { id: 'landscaping', icon: '🌿', name: 'Landscaping' },
  { id: 'housekeeping', icon: '🧹', name: 'Housekeeping' },
  { id: 'pest_control', icon: '🐛', name: 'Pest Control' },
  { id: 'pool_service', icon: '🏊', name: 'Pool Service' },
  { id: 'hvac_maintenance', icon: '🌬️', name: 'HVAC Service' },
  { id: 'gutter_cleaning', icon: '🏠', name: 'Gutter Cleaning' },
  { id: 'window_washing', icon: '✨', name: 'Window Washing' },
  { id: 'chimney_sweep', icon: '🔥', name: 'Chimney Sweep' },
  { id: 'pressure_washing', icon: '💧', name: 'Pressure Washing' },
  { id: 'septic_service', icon: '🌿', name: 'Septic Service' },
  { id: 'security_monitoring', icon: '🔒', name: 'Security' },
  { id: 'other_recurring', icon: '🔧', name: 'Other' },
]

const contractorTrades = [
  { id: 'plumbing', icon: '🔧', name: 'Plumbing' },
  { id: 'electrical', icon: '⚡', name: 'Electrical' },
  { id: 'hvac', icon: '🌬️', name: 'HVAC' },
  { id: 'roofing', icon: '🏠', name: 'Roofing' },
  { id: 'painting', icon: '🎨', name: 'Painting' },
  { id: 'flooring', icon: '🪵', name: 'Flooring' },
  { id: 'carpentry', icon: '🪚', name: 'Carpentry' },
  { id: 'masonry', icon: '🧱', name: 'Masonry' },
  { id: 'appliance_repair', icon: '🔌', name: 'Appliance Repair' },
  { id: 'landscaping_project', icon: '🌿', name: 'Landscaping' },
  { id: 'general', icon: '🔨', name: 'General' },
  { id: 'other_contractor', icon: '🔧', name: 'Other' },
]

const frequencies = [
  'Weekly', 'Every 2 weeks', 'Monthly', 'Every 2 months',
  'Quarterly', 'Every 6 months', 'Annually', 'As needed',
]

const jobStatuses = ['Scheduled', 'In Progress', 'Completed', 'On Hold', 'Cancelled']

export default function AddService({ userId, propertyId, onClose, onSaved }) {
  const [serviceType, setServiceType] = useState(null) // 'recurring' or 'contractor'
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [focus, setFocus] = useState('')
  const [loading, setLoading] = useState(false)
  const [alert, setAlert] = useState(null)
  const [step, setStep] = useState(1)

  const [recurringForm, setRecurringForm] = useState({
    provider_name: '', provider_phone: '', provider_email: '',
    frequency: '', cost: '', next_date: '', notes: '',
  })

  const [contractorForm, setContractorForm] = useState({
    provider_name: '', provider_phone: '', provider_email: '',
    description: '', status: 'Scheduled', cost: '', job_date: '', notes: '',
  })

  const setR = (field) => (e) => {
    setRecurringForm(f => ({ ...f, [field]: e.target.value }))
    setAlert(null)
  }

  const setC = (field) => (e) => {
    setContractorForm(f => ({ ...f, [field]: e.target.value }))
    setAlert(null)
  }

  const selectedService = serviceType === 'recurring'
    ? recurringServices.find(s => s.id === selectedCategory)
    : contractorTrades.find(s => s.id === selectedCategory)

  const handleSave = async () => {
    if (!selectedCategory) {
      setAlert({ type: 'error', msg: 'Please select a service type.' }); return
    }
    setLoading(true)
    setAlert(null)

    const baseData = {
      user_id: userId,
      property_id: propertyId,
      service_type: serviceType,
      category: selectedCategory,
      name: selectedService?.name || '',
      icon: selectedService?.icon || '🔧',
    }

    let insertData
    if (serviceType === 'recurring') {
      insertData = {
        ...baseData,
        provider_name: recurringForm.provider_name,
        provider_phone: recurringForm.provider_phone,
        provider_email: recurringForm.provider_email,
        frequency: recurringForm.frequency,
        cost: recurringForm.cost ? parseFloat(recurringForm.cost) : null,
        next_date: recurringForm.next_date || null,
        notes: recurringForm.notes,
        status: 'active',
      }
    } else {
      insertData = {
        ...baseData,
        provider_name: contractorForm.provider_name,
        provider_phone: contractorForm.provider_phone,
        provider_email: contractorForm.provider_email,
        description: contractorForm.description,
        status: contractorForm.status,
        cost: contractorForm.cost ? parseFloat(contractorForm.cost) : null,
        job_date: contractorForm.job_date || null,
        notes: contractorForm.notes,
      }
    }

    const { error } = await supabase.from('services').insert(insertData)

    if (error) {
      setAlert({ type: 'error', msg: `Error saving: ${error.message}` })
      setLoading(false)
    } else {
      onSaved()
    }
  }

  return (
    <div style={S.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div style={S.modal}>
        <div style={S.header}>
          <div style={S.title}>
            {step === 1 ? 'Add Service' : step === 2 ? 'Select Category' : 'Service Details'}
          </div>
          <button style={S.closeBtn} onClick={onClose}>×</button>
        </div>

        <div style={S.body}>
          <div style={S.stepBar}>
            {[1, 2, 3].map(s => (
              <div key={s} style={S.stepBarItem(s <= step)} />
            ))}
          </div>

          {alert && <div style={S.alert(alert.type)}>{alert.msg}</div>}

          {/* STEP 1 — Recurring or One-Time */}
          {step === 1 && (
            <div>
              <div style={S.sectionTitle}>What type of service?</div>
              <div style={S.typeToggle}>
                <div
                  style={S.typeBtn(serviceType === 'recurring')}
                  onClick={() => { setServiceType('recurring'); setSelectedCategory(null); setStep(2) }}
                >
                  <div style={S.typeBtnIcon}>🔄</div>
                  <div style={S.typeBtnLabel(serviceType === 'recurring')}>Recurring Service</div>
                  <div style={S.typeBtnSub(serviceType === 'recurring')}>Landscaping, housekeeping, pest control...</div>
                </div>
                <div
                  style={S.typeBtn(serviceType === 'contractor')}
                  onClick={() => { setServiceType('contractor'); setSelectedCategory(null); setStep(2) }}
                >
                  <div style={S.typeBtnIcon}>🔨</div>
                  <div style={S.typeBtnLabel(serviceType === 'contractor')}>Contractor Job</div>
                  <div style={S.typeBtnSub(serviceType === 'contractor')}>Plumbing, electrical, roofing...</div>
                </div>
              </div>
              <button style={S.cancelBtn} onClick={onClose}>Cancel</button>
            </div>
          )}

          {/* STEP 2 — Select category */}
          {step === 2 && (
            <div>
              <div style={S.sectionTitle}>
                {serviceType === 'recurring' ? 'Select Service Type' : 'Select Trade'}
              </div>
              <div style={S.serviceGrid}>
                {(serviceType === 'recurring' ? recurringServices : contractorTrades).map(s => (
                  <div
                    key={s.id}
                    style={S.serviceCard(selectedCategory === s.id)}
                    onClick={() => { setSelectedCategory(s.id); setAlert(null); setStep(3) }}
                  >
                    <div style={S.serviceIcon}>{s.icon}</div>
                    <div style={S.serviceName(selectedCategory === s.id)}>{s.name}</div>
                  </div>
                ))}
              </div>
              <button style={S.cancelBtn} onClick={() => setStep(1)}>Back</button>
            </div>
          )}

          {/* STEP 3 — Details */}
          {step === 3 && selectedService && (
            <div>
              {/* Service header */}
              <div style={{
                display: 'flex', alignItems: 'center', gap: '10px',
                marginBottom: '20px', padding: '12px 14px',
                background: C.bg, borderRadius: '10px', border: `1px solid ${C.border}`,
              }}>
                <div style={{ fontSize: '28px' }}>{selectedService.icon}</div>
                <div>
                  <div style={{ fontSize: '16px', fontWeight: '700', color: C.brown }}>{selectedService.name}</div>
                  <div style={{ fontSize: '12px', color: C.muted, fontFamily: 'Calibri, sans-serif' }}>
                    {serviceType === 'recurring' ? 'Recurring Service' : 'Contractor Job'}
                  </div>
                </div>
              </div>

              <div style={S.sectionTitle}>Provider Information</div>

              <label style={S.label}>Provider / Company Name <span style={{ color: C.muted }}>(optional)</span></label>
              <input
                style={S.input(focus === 'pname')}
                placeholder="e.g. Green Valley Landscaping"
                value={serviceType === 'recurring' ? recurringForm.provider_name : contractorForm.provider_name}
                onChange={serviceType === 'recurring' ? setR('provider_name') : setC('provider_name')}
                onFocus={() => setFocus('pname')}
                onBlur={() => setFocus('')}
                autoComplete="off"
              />

              <div style={S.row}>
                <div style={S.field}>
                  <label style={S.label}>Phone <span style={{ color: C.muted }}>(optional)</span></label>
                  <input
                    style={S.input(focus === 'pphone')}
                    placeholder="(707) 555-0100"
                    value={serviceType === 'recurring' ? recurringForm.provider_phone : contractorForm.provider_phone}
                    onChange={serviceType === 'recurring' ? setR('provider_phone') : setC('provider_phone')}
                    onFocus={() => setFocus('pphone')}
                    onBlur={() => setFocus('')}
                    autoComplete="off"
                  />
                </div>
                <div style={S.field}>
                  <label style={S.label}>Email <span style={{ color: C.muted }}>(optional)</span></label>
                  <input
                    style={S.input(focus === 'pemail')}
                    placeholder="provider@email.com"
                    value={serviceType === 'recurring' ? recurringForm.provider_email : contractorForm.provider_email}
                    onChange={serviceType === 'recurring' ? setR('provider_email') : setC('provider_email')}
                    onFocus={() => setFocus('pemail')}
                    onBlur={() => setFocus('')}
                    autoComplete="off"
                  />
                </div>
              </div>

              {/* Recurring-specific fields */}
              {serviceType === 'recurring' && (
                <>
                  <div style={S.row}>
                    <div style={S.field}>
                      <label style={S.label}>Frequency</label>
                      <select
                        style={S.select(focus === 'frequency')}
                        value={recurringForm.frequency}
                        onChange={setR('frequency')}
                        onFocus={() => setFocus('frequency')}
                        onBlur={() => setFocus('')}
                      >
                        <option value="">Select...</option>
                        {frequencies.map(f => <option key={f} value={f}>{f}</option>)}
                      </select>
                    </div>
                    <div style={S.field}>
                      <label style={S.label}>Cost per Visit <span style={{ color: C.muted }}>(optional)</span></label>
                      <input
                        style={S.input(focus === 'cost')}
                        placeholder="e.g. 150"
                        value={recurringForm.cost}
                        onChange={setR('cost')}
                        onFocus={() => setFocus('cost')}
                        onBlur={() => setFocus('')}
                        type="number"
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <label style={S.label}>Next Scheduled Date <span style={{ color: C.muted }}>(optional)</span></label>
                  <input
                    style={S.input(focus === 'next_date')}
                    type="date"
                    value={recurringForm.next_date}
                    onChange={setR('next_date')}
                    onFocus={() => setFocus('next_date')}
                    onBlur={() => setFocus('')}
                  />
                </>
              )}

              {/* Contractor-specific fields */}
              {serviceType === 'contractor' && (
                <>
                  <label style={S.label}>Job Description</label>
                  <input
                    style={S.input(focus === 'desc')}
                    placeholder="e.g. Replace kitchen faucet and fix leak under sink"
                    value={contractorForm.description}
                    onChange={setC('description')}
                    onFocus={() => setFocus('desc')}
                    onBlur={() => setFocus('')}
                    autoComplete="off"
                  />
                  <div style={S.row}>
                    <div style={S.field}>
                      <label style={S.label}>Status</label>
                      <select
                        style={S.select(focus === 'status')}
                        value={contractorForm.status}
                        onChange={setC('status')}
                        onFocus={() => setFocus('status')}
                        onBlur={() => setFocus('')}
                      >
                        {jobStatuses.map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>
                    <div style={S.field}>
                      <label style={S.label}>Estimated Cost <span style={{ color: C.muted }}>(optional)</span></label>
                      <input
                        style={S.input(focus === 'cost')}
                        placeholder="e.g. 350"
                        value={contractorForm.cost}
                        onChange={setC('cost')}
                        onFocus={() => setFocus('cost')}
                        onBlur={() => setFocus('')}
                        type="number"
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <label style={S.label}>Job Date <span style={{ color: C.muted }}>(optional)</span></label>
                  <input
                    style={S.input(focus === 'job_date')}
                    type="date"
                    value={contractorForm.job_date}
                    onChange={setC('job_date')}
                    onFocus={() => setFocus('job_date')}
                    onBlur={() => setFocus('')}
                  />
                </>
              )}

              <label style={S.label}>Notes <span style={{ color: C.muted }}>(optional)</span></label>
              <textarea
                style={S.textarea(focus === 'notes')}
                placeholder="Any additional details, access instructions, or notes..."
                value={serviceType === 'recurring' ? recurringForm.notes : contractorForm.notes}
                onChange={serviceType === 'recurring' ? setR('notes') : setC('notes')}
                onFocus={() => setFocus('notes')}
                onBlur={() => setFocus('')}
              />

              <div style={{ display: 'flex', gap: '10px' }}>
                <button style={{ ...S.cancelBtn, marginTop: 0, flex: 1 }} onClick={() => setStep(2)}>Back</button>
                <button style={{ ...S.btn(loading), flex: 2, marginTop: 0 }} onClick={handleSave} disabled={loading}>
                  {loading ? 'Saving...' : 'Save Service'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}